import { createAction } from '@reduxjs/toolkit';
import * as types from './type';
import axiosAdapter from '../../../utils/Adapters';
import { CMSAPI_INDEX } from '../../../utils/CmsAPI';
import config from '../../../config';

const reset = createAction(types.ACTION_RESET);
const requestFetch = createAction(types.ACTION_REQUEST);
const receiveSuccess = createAction(types.ACTION_SUCCESS);
const receiveError = createAction(types.ACTION_ERROR);

const massageData = (response, projectName) => {
  const responseData = response.data;

  if (projectName === 'RMIP') {
    return {
      lists: responseData.result.assets.map((v, k) => {
        return {
          fileName: v.path.split('/').slice(-1)[0].replace('.xml', ''),
          content: {
            en: {
              thumbnail: v.metadata[`TeamSite/Metadata/EN/indexPhoto`],
              alt: v.metadata[`TeamSite/Metadata/EN/indexPhotoAltText`],
              headline: v.metadata[`TeamSite/Metadata/EN/contentTitle`],
              abstract: v.metadata[`TeamSite/Metadata/EN/abstract`],
              link: `${config.researchDomain}/en/article/${v.metadata[`TeamSite/Metadata/id`]}`,
            },
            tc: {
              thumbnail: v.metadata[`TeamSite/Metadata/TC/indexPhoto`],
              alt: v.metadata[`TeamSite/Metadata/TC/indexPhotoAltText`],
              headline: v.metadata[`TeamSite/Metadata/TC/contentTitle`],
              abstract: v.metadata[`TeamSite/Metadata/TC/abstract`],
              link: `${config.researchDomain}/en/article/${v.metadata[`TeamSite/Metadata/id`]}`,
            },
            sc: {
              thumbnail: v.metadata[`TeamSite/Metadata/SC/indexPhoto`],
              alt: v.metadata[`TeamSite/Metadata/SC/indexPhotoAltText`],
              headline: v.metadata[`TeamSite/Metadata/SC/contentTitle`],
              abstract: v.metadata[`TeamSite/Metadata/SC/abstract`],
              link: `${config.researchDomain}/en/article/${v.metadata[`TeamSite/Metadata/id`]}`,
            },
          },
        };
      }),
      total: responseData.total,
    };
  }
  return {
    lists: responseData.result.assets.map((v, k) => {
      const fileName = v.path.split('/').slice(-1)[0].replace('.xml', '');
      return {
        fileName,
        content: {
          en: {
            thumbnail: v.content.content.en.thumbnail,
            alt: v.content.content.en.headline,
            headline: v.content.content.en.headline,
            abstract: v.content.content.en.abstract,
            link: `${config.routePathTo}/en/s/${fileName}`,
          },
          tc: {
            thumbnail: v.content.content.tc.thumbnail,
            alt: v.content.content.tc.headline,
            headline: v.content.content.tc.headline,
            abstract: v.content.content.tc.abstract,
            link: `${config.routePathTo}/tc/s/${fileName}`,
          },
          sc: {
            thumbnail: v.content.content.sc.thumbnail,
            alt: v.content.content.sc.headline,
            headline: v.content.content.sc.headline,
            abstract: v.content.content.sc.abstract,
            link: `${config.routePathTo}/sc/s/${fileName}`,
          },
        },
      };
    }),
    total: responseData.total,
  };
};

const messageError = (error) => {
  const message =
    ((((error || {}).response || {}).data || {}).error || {}).message || error.message;
  return message;
};

const fetchData = (query, start, itemsPerPage, projectName) => {
  const url = CMSAPI_INDEX(
    config.lscsPath,
    query,
    start,
    itemsPerPage,
    projectName === 'RMIP' ? 'RMIP' : config.cmsProjectName,
  );

  return axiosAdapter({
    url,
  });
};

const resetWidgetArticleList = () => {
  return (dispatch) => {
    dispatch(reset());
  };
};

const getWidgetArticleList = (query, start = 0, itemsPerPage, projectName) => {
  return (dispatch) => {
    dispatch(requestFetch({ query, start, itemsPerPage, projectName }));
    return fetchData(query, start, itemsPerPage, projectName)
      .then((response) => massageData(response, projectName))
      .then((data) => {
        dispatch(receiveSuccess(data));
      })
      .catch((error) => {
        const message = messageError(error);
        dispatch(receiveError(message));
      });
  };
};

export { getWidgetArticleList, resetWidgetArticleList };
